import React, { useMemo } from "react";
import {
  canStartNewDiditSession,
  coerceKycVerified,
  kycBadgeLabel,
  kycBadgeTone,
  KYC,
} from "../../utils/kycVerified";
import { openKycVerification } from "../../ui/Pages/KycVara/openKycVerification";

/** Settings → Identity verification. Both buttons open the KYC VARA modal on this page. */
const IdentityVerificationSection = ({ userDetails }) => {
  const tier = useMemo(
    () => coerceKycVerified(userDetails?.kycVerified),
    [userDetails]
  );
  const tone = kycBadgeTone(tier);
  const label = kycBadgeLabel(tier);

  const showStartCta = canStartNewDiditSession(tier);

  return (
    <section
      className="settings-page__card identity-verification-section"
      aria-labelledby="identity-verification-heading"
    >
      <div className="settings-page__card-head">
        <h2 id="identity-verification-heading" className="settings-page__card-title">
          Identity verification
        </h2>
        <p className="settings-page__card-desc">
          Complete liveness and Emirates ID or passport checks to unlock withdrawals, deposits, and higher limits.
        </p>
      </div>
      <div className="settings-page__rows">
        <div className="settings-page__row settings-page__row--last identity-section__row">
          <div className="settings-page__row-main">
            <div className="settings-page__icon" aria-hidden="true">
              <img src="/images/lock_icon2.svg" alt="" className="identity-section__lock-icon" />
            </div>
            <div>
              <div className="settings-page__row-title">Status</div>
              <div className="settings-page__row-text">
                KYC is required for a secure trading environment.
              </div>
            </div>
          </div>
          <div className="settings-page__row-aside identity-section__aside">
            <span className={`identity-section__badge identity-section__badge--${tone}`} role="status">
              {label}
            </span>
            {showStartCta ? (
              <button type="button" className="settings-page__pill" onClick={openKycVerification}>
                {tier === KYC.REJECTED || tier === KYC.REKYC_REQUIRED ? "Try again" : "Verify now"}
              </button>
            ) : null}
            <button
              type="button"
              className="settings-page__pill settings-page__pill--link"
              onClick={openKycVerification}
            >
              View verification
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IdentityVerificationSection;
